import 'react';
import Style from './style.js';
import { jsx } from '@emotion/react';

var FadeInContainer = _ref => {
  var {
    children,
    slide = false,
    speed = '350ms'
  } = _ref;
  return jsx(Style.FadeInContainer, {
    withSlide: slide,
    animationSpeed: speed
  }, children);
};
var {
  opacityInAnimationStyle
} = Style;

export { FadeInContainer, opacityInAnimationStyle };
